import React, { useEffect, useState } from 'react';
import { useRouterStore } from '../../hooks';
import {
    cleanCatalogsStore,
    cleanPackageInstanceItem,
    getCatalogsDataUnitTypeSelect,
    getCatalogsOriginalUnitTypeSelect,
    getTariffPackageInstances,
} from '../../middleware';
import { Catcher } from '../Catcher';
import { ShowTariffPackageInstance } from './Components';

export const TariffPackageInstanceView: React.FC = () => {
    const routerStore = useRouterStore();
    const [id, setId] = useState('');

    const cleanStore = (): void => {
        cleanPackageInstanceItem();
    };

    const goToList = (): void => {
        routerStore.goTo('TariffPackageInstancesList');
        cleanStore();
    };

    const _getItem = async (id: string): Promise<void> => {
        const isGetOk = await getTariffPackageInstances(id);
        if (!isGetOk) {
            goToList();
        }
    };
    useEffect(() => {
        getCatalogsOriginalUnitTypeSelect();
        getCatalogsDataUnitTypeSelect();
        return (): void => {
            cleanStore();
            cleanCatalogsStore();
        };
    }, []);

    useEffect(() => {
        if (id) {
            _getItem(id);
        }
    }, [id]);

    useEffect(() => {
        if (routerStore.routerState.params.id && routerStore.routerState.routeName === 'TariffPackageInstanceView') {
            setId(routerStore.routerState.params.id);
        }
    }, [routerStore.routerState.params.id]);

    return (
        <Catcher>
            <ShowTariffPackageInstance />
        </Catcher>
    );
};
